import {createContext} from 'react';

export const ComparisonTestIdContext = createContext<string | undefined>(undefined);
